import React from "react";
import NewsManagement from "../Components/Ambassador/News/NewsManagement";

const AmbassadorNewsManagementPage: React.FC = () => <NewsManagement />;

export default AmbassadorNewsManagementPage;
